export default function IosTennisballOutline() {
  return (
    <div
      className="ion-icon-ios-tennisball-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M464,256c0-114.863-93.13-208-208-208C141.137,48,48,141.136,48,256c0,114.863,93.137,208,208,208
	c2.541,0,5.068-0.062,7.587-0.152c0.479-0.017,0.957-0.034,1.435-0.055c0.942-0.04,1.884-0.083,2.823-0.136
	c0.85-0.047,1.698-0.104,2.547-0.161c0.639-0.044,1.279-0.08,1.917-0.13c1.354-0.104,2.705-0.221,4.055-0.352
	c0-0.003,0-0.006,0-0.009c97.47-9.474,175.229-86.229,186.274-183.223c0.02-0.001,0.038,0,0.057-0.001
	c0.604-5.315,1.002-10.667,1.196-16.05c-0.016,0.001-0.032,0.001-0.049,0.001C463.937,261.166,464,258.591,464,256z M446.665,256
	c0,2.568-0.066,5.121-0.167,7.664c-23.639-1.076-46.677-6.106-68.616-15.005c-25.791-10.458-48.938-25.831-68.797-45.691
	c-19.86-19.86-35.233-43.007-45.692-68.797c-8.903-21.956-13.935-45.014-15.006-68.67c2.527-0.1,5.063-0.165,7.614-0.165
	C361.13,65.335,446.665,150.869,446.665,256z M65.337,256c0-1.318,0.023-2.631,0.05-3.942c22.476,1.379,44.388,6.337,65.3,14.817
	c25.791,10.458,48.938,25.831,68.798,45.691c19.86,19.859,35.232,43.007,45.691,68.798c8.474,20.896,13.43,42.792,14.814,65.249
	c-1.328,0.027-2.656,0.051-3.99,0.051C150.87,446.664,65.336,361.13,65.337,256z M275.943,445.623
	c-3.273-52.566-24.974-104.198-65.145-144.369c-40.186-40.186-91.84-61.889-144.427-65.15
	c9.172-88.053,78.52-158.478,166.074-169.313c2.595,53.64,24.36,106.525,65.326,147.49c40.949,40.952,93.811,62.713,147.433,65.322
	C434.351,367.118,363.957,436.432,275.943,445.623z"/>
</svg>
`,
      }}
    />
  )
}
